module.exports = __webpack_public_path__ + "img/newsletter18.493731d2.jpeg";